import { render, staticRenderFns } from "./TopicConfig.vue?vue&type=template&id=a5048452"
import script from "./TopicConfig.vue?vue&type=script&lang=js"
export * from "./TopicConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports